module.exports = __webpack_public_path__ + "media/images/redesign-images/home/collegiate-logos/duquesne-university-829f79042dea2b3ab47e6bbea8439561.svg";